import { render, staticRenderFns } from "./ImgRoll.vue?vue&type=template&id=b6a6ab4a&scoped=true"
import script from "./ImgRoll.vue?vue&type=script&lang=js"
export * from "./ImgRoll.vue?vue&type=script&lang=js"
import style0 from "./ImgRoll.vue?vue&type=style&index=0&id=b6a6ab4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6ab4a",
  null
  
)

export default component.exports